export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('noticesDragging', {
    mounted(el, binding) {
      const handler = (event: any) => {

        const elpos = el.getBoundingClientRect();
        const isAbove = event.detail.clientY < elpos.top + elpos.height
          && event.detail.clientY > elpos.top;

        const isAboveUpperHalf = event.detail.clientY < elpos.top + (elpos.height / 2);

        const payload = {
          element: event.detail.element,
          clientX: event.detail.clientX,
          clientY: event.detail.clientY,
          isDragging: event.detail.isDragging,
          isAbove: isAbove,
          isAboveUpperHalf: isAboveUpperHalf,
          isBeingDragged: el == event.detail.element,
          isDroppable: isAbove && (
            event.detail.clientY < elpos.top + 30 ||
            event.detail.clientY > elpos.top + elpos.height - 30
          )
        }

        binding.value(payload)
      };

      el.__veNoticesDraggingHandler = handler;

      document.addEventListener('noticesDragging', handler)
    },
    unmounted(el) {
      if (el.__veNoticesDraggingHandler) {
        document.removeEventListener('noticesDragging', el.__veNoticesDraggingHandler);
        delete el.__veNoticesDraggingHandler;
      }
    }
  })
})
